// ----
// Social Cobalt JS
// ----
(function ($, Cobalt, undefined) {
    Cobalt.Social_Twitter = {
        initialize: function () {
            $('.twitter-share').removeClass('twitter-share-button');
            window.twttr = (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0],
                  t = window.twttr || {};
                if (d.getElementById(id)) return t;
                js = d.createElement(s);
                js.id = id;
                js.src = "https://platform.twitter.com/widgets.js";
                fjs.parentNode.insertBefore(js, fjs);

                t._e = [];
                t.ready = function (f) {
                    t._e.push(f);
                };
                if (window._ga) {
                    window._ga.trackTwitter();
                }
                return t;
            })(document, "script", "twitter-wjs");
            twttr.ready(function (twttr) {
                $('.twitter-share').addClass('twitter-share-button');
            });
             
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Social_Twitter.js